import switchLang from "@/helpers/switchLanguage";

export default {
  methods: {
    getName(name) {
      const Languages = {
        en: {
          name: `${switchLang[localStorage.langType].langSwitcher.english} Language`,
          imageName: "flag-uk.png",
        },
        se: {
          name: `${switchLang[localStorage.langType].langSwitcher.swedish} Language`,
          imageName: "flag-sv.png",
        },
        no: {
          name: `${switchLang[localStorage.langType].langSwitcher.norwegian} Language`,
          imageName: "flag-no.png",
        },
        is: {
          name: `${switchLang[localStorage.langType].langSwitcher.icelandic} Language`,
          imageName: "flag-is.png",
        }
      };
      return Languages[name];
    },
  }
};
